/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Bид элемента паджинации.
   */
  app.BasePaginationView = app.View.extend({
    el: '.b-pagination',
    template: '#pagination-select-page-template',
    events: {
      'click .b-pagination__page_space': 'showSelectPageForm',
      'click .js-page-select-cancel': 'hideSelectPageForm',
      'click .js-page-select-submit': 'changePage',
      'keyup .js-select-page-input': 'validate'
    },
    /**
     * Находимся ли мы в процессе перехода на новую страницу
     */
    assigned: false,
    beforeRun: function (data) {
      this._setOptions(data);
      this.template = app.helpers.TemplateHelper.getTemplate(this.template);
    },
    run: function () {
      this.render();
    },
    render: function () {
      this.assigned = false;
      var renderOptions = this._getRenderParams(),
        html = this.template(renderOptions);
      if (this.$('.js-page-select-form').length) {
        this.$('.js-page-select-form').replaceWith(html);
        return this;
      }
      this.$el.append(html);
      return this;
    },
    /**
     * Показывает форму выбора страницы
     */
    showSelectPageForm: function () {
      if (!app.isMobile) {
        this.$('> span, > a').addClass('not_display');
        this.$('.js-page-select-form').removeClass('not_display');
        this.assigned = false;
      }
    },
    /**
     * Скрывает форму выбора страницы
     */
    hideSelectPageForm: function () {
      if (!app.isMobile) {
        this.$('.js-page-select-form').addClass('not_display');
        this.$('a.not_display, span.not_display').removeClass('not_display');
      }
    },
    /**
     * Обрабатывает событие смены страницы
     */
    changePage: function () {
      this.validate();
      if (this.assigned) {
        return;
      }
      this.assigned = true;
      this._change();
      this.hideSelectPageForm();
    },
    /**
     * Валидирует ввод пользователя в поле
     * @param e
     */
    validate: function (e) {
      if (e && e.keyCode == 13) {
        this.changePage();
        return;
      }
      var input = this.$('.js-select-page-input'),
        value = input.val(),
        min = parseInt(input.attr('min'), 10),
        max = parseInt(input.attr('max'), 10);
      if (value) {
        if (!value.match(/(\d+)/i)) {
          input.val('');
          return;
        }
        value = parseInt(value, 10);
        if (value < min) {
          input.val(min);
          return;
        }
        if (value > max) {
          input.val(max);
        }
      }
    },
    /**
     * Меняет страницу
     * @private
     */
    _change: function () {
      var pathname = location.pathname,
        search = location.search,
        value = this.$('.js-select-page-input').val(),
        pagePathPart = '';
      if (value) {
        if (value > 1) {
          pagePathPart = '/p' + value.toString();
        }
        if (pathname.match(/(\/p\d+)/i)) {
          pathname = pathname.replace(/\/p\d+/, pagePathPart);
        } else {
          pathname += pagePathPart.replace('/', '') + '/';
        }
        location.assign(pathname + search);
      }
    },
    /**
     * Формирует объект с параметрами для рендеринга формы выбора страницы
     * @returns {{min: number, max: number}}
     * @private
     */
    _getRenderParams: function () {
      var pageElements = this.$('.b-pagination__page'),
        pages = [],
        that = this,
        result = {
          min: 0,
          max: 0
        };
      pageElements.each(function () {
        pages.push(parseInt(that.$(this).data('page'), 10) + 1);
      });
      result.min = Math.min.apply(this, pages);
      result.max = Math.max.apply(this, pages);
      return result;
    },
    /**
     * Устанавливает опции для view
     * @param options
     * @private
     */
    _setOptions: function (options) {
      for (var i in options) {
        if (options.hasOwnProperty(i)) {
          this[i] = options[i];
        }
      }
    }
  });
})();

}.call(window));